module.exports = __webpack_public_path__ + "img/appAsset-brand--paypalLogo.ecd965e6.svg";